import React from 'react';
import get from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../CommonComponents/OPL/Select/Select/Select';
import { AllocationStrategyType, AssetClassDTO } from '../ManageExcessCashModal.meta';

interface Props {
  formKey?: string;
  excessCashAllocationOptions: { label: string; value: number }[];
  marketAssumptions: AssetClassDTO[];
}

export const AllocateExcessCashMethod = ({
  formKey = 'ExcessCashFlowStrategy.type',
  excessCashAllocationOptions,
  marketAssumptions,
}: Props) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const onAllocationSelect = (type: number | null) => {
    if (type === AllocationStrategyType.MarketAssumptions) {
      setValue('ExcessCashFlowStrategy.data', { marketAssumptions });
    } else if (type === AllocationStrategyType.HypotheticalReturn) {
      setValue('ExcessCashFlowStrategy.data', { hypotheticalReturnPercent: null });
    } else if (type === AllocationStrategyType.PortfolioGroup) {
      setValue('ExcessCashFlowStrategy.data', { modelPortfolios: null });
    } else if (type === AllocationStrategyType.ExistingAccount) {
      setValue('ExcessCashFlowStrategy.data', { existingAccountId: null });
    } else {
      setValue('ExcessCashFlowStrategy.data', null);
    }
  };

  const error = get(errors, formKey);

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field: { value, onChange } }) => (
        <Select
          isPortal
          label="Choose a source to assign a return to saved cash"
          value={excessCashAllocationOptions.find(({ value: _value }) => value === _value)}
          options={excessCashAllocationOptions}
          onChange={opt => {
            if (opt) {
              onAllocationSelect(opt.value);
              onChange(opt.value);
            }
          }}
          formVariant={error && 'error'}
          helperText={error?.message}
        />
      )}
    />
  );
};
